module.exports = __webpack_public_path__ + "static/img/step-05.3ac8ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-05.png
// module id = J6He
// module chunks = 1